module.exports = __webpack_public_path__ + "img/banner_about_m.b1c50957.png";